module.exports = __webpack_public_path__ + "assets/img/documentSearch.f485b009.png";